import React, { useContext } from 'react';
import { SiteSettingsContext } from '../../utils/context';
import Paragraphs from '../../components/02_molecules/Paragraphs';

const ErrorNotFound = () => {
  const { notFoundPage } = useContext(SiteSettingsContext);
  return <Paragraphs blocks={notFoundPage.blocks} />;
};
export default ErrorNotFound;
